// query-keys/job-keys.js
import { queryClient } from "utils/react-query";

const collection = "contracts";

export const contractKeys = {
  // Base keys
  all: [collection],
  meta: (id) => [collection, "meta", id],
  details: () => [collection, "detail"],
  detail: (id) => [...contractKeys.details(), id],
  jobs: (contractId) => [...contractKeys.detail(contractId), "contracts"], 
};

export function invalidateContractQueries() {
  const predicates = [
    // Invalidate all job lists
    ({ queryKey }) => queryKey[0] === collection,
  ];

  predicates.forEach((predicate) => {
    queryClient.invalidateQueries({ predicate });
  });
}

// Additional helper for invalidating all job queries
export function invalidateAllContractQueries() {
  queryClient.invalidateQueries({
    predicate: ({ queryKey }) => queryKey[0] === collection,
  });
}
